import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Input from '../common/Input';
import { format } from 'date-fns';
import { Button } from 'react-bootstrap';
import { getSalesByDate, getSalesByDatesCriteria } from '../service/saleService';
import subDays from 'date-fns/subDays';
import { FaSearch } from 'react-icons/fa';
import { IoMdList } from 'react-icons/io';
import DataTable from '../common/DataTable';
import { toast } from 'react-toastify';
import FilterBox from '../common/FilterBox';
import SelectBox from '../common/SelectBox';
import * as d3c from 'd3-collection';
import { isAdmin } from '../service/authService';
import { CSVLink } from 'react-csv';

const SalesHistory = () => {
   const [startDate, setStartDate] = useState(subDays(new Date(), 0));
   const [endDate, setEndDate] = useState(new Date());
   const [keyValue, setKeyValue] = useState('');
   const [keySearch, setKeySearch] = useState(null);
   const [items, setItems] = useState([]);
   const [filterValue, setFilterValue] = useState('');
   const [currentData, setCurrentData] = useState([]);
   const [salesStatus, setSalesStatus] = useState([]);
   const [selectedStatus, setSelectedStatus] = useState({});

   const options = [
      { value: '', label: '' },
      { value: 'mobile', label: 'By Mobile' },
      { value: 'meter', label: 'By Meter' },
      { value: 'transactionId', label: 'By Transaction Id' },
   ];

   let pageSize = 100;

   const exportHeaders = [
      { label: 'Transaction Id', key: 'transactionId' },
      { label: 'Phone Number', key: 'buyerIdentifier' },
      { label: 'Meter', key: 'meterNumber' },
      { label: 'Amount', key: 'saleAmount' },
      { label: 'Status', key: 'statusId.saleStatusName' },
      { label: 'Time', key: 'saleDateTime' },
   ];

   const columns = [
      {
         columnCaption: 'Transaction Id',
         columnKey: 'transactionId',
         type: 'text',
         content: (item) => <Link to={`/SaleHistoryDetails/${item.transactionId}`}>{item.transactionId}</Link>,
      },
      {
         columnCaption: 'Phone Number',
         columnKey: 'msisdn',
      },
      {
         columnCaption: 'Receiver Id',
         columnKey: 'receiverId',
      },
      {
         columnCaption: 'Amount',
         columnKey: 'saleAmount',
      },
      {
         columnCaption: 'Customer Names',
         columnKey: 'customerId.customerNames',
      },
      {
         columnCaption: 'Status',
         columnKey: 'statusId.saleStatusName',
      },
      {
         columnCaption: 'Time',
         columnKey: 'saleDateTime',
      },
   ];

   const fetchSales = (salesStatuses) => {
      let formatedStartDate = format(startDate, 'yyyy-MM-dd');
      let formatedEndDate = format(endDate, 'yyyy-MM-dd');
      getSalesByDate(formatedStartDate, formatedEndDate, -1).then((result) => {
         let sales = result.data.data;
         setCurrentData(sales);
         let groupedStatus = [{ key: '-1', value: { name: 'Clear All' } }, ...groupByStatus(sales)];
         setSalesStatus(groupedStatus);
         setItems(sales);
      });
   };

   const groupByStatus = (data) => {
      return d3c
         .nest()
         .key((d) => {
            return d.statusId.saleStatusId;
         })
         .rollup((v) => ({
            count: v.length,
            name: v[0].statusId.saleStatusName,
         }))
         .entries(data);
   };

   const onSelectStatus = (status) => {
      setSelectedStatus((prevState) => ({ ...prevState, ...status }));
      let searchItems = [...currentData];
      if (status.key !== '-1') {
         let filteredItems = searchItems.filter((dataItem) => {
            if (dataItem.statusId.saleStatusId === parseInt(status.key)) return dataItem;
         });
         setItems(filteredItems);
      } else {
         setItems(searchItems);
      }
   };

   const onSearch = (e) => {
      e.preventDefault();
      let value = e.target.value;
      setFilterValue(value);
      let searchItems = [...currentData];
      let filteredItems = searchItems.filter((dataItem) => {
         if (
            dataItem.saleAmount.toString().includes(value) ||
            dataItem.saleDateTime.toUpperCase().includes(value.toUpperCase()) ||
            dataItem.transactionId.toUpperCase().includes(value.toUpperCase()) ||
            dataItem.buyerIdentifier.toUpperCase().includes(value.toUpperCase()) ||
            dataItem.statusId.saleStatusName.toUpperCase().includes(value.toUpperCase()) ||
            dataItem.meterNumber.toUpperCase().includes(value.toUpperCase()) ||
            dataItem.customerId.customerNames.toUpperCase().includes(value.toUpperCase())
         )
            return dataItem;
      });
      setItems(filteredItems);
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      let formatedStartDate = format(startDate, 'yyyy-MM-dd');
      let formatedEndDate = format(endDate, 'yyyy-MM-dd');
      if (keySearch) {
         getSalesByDatesCriteria(formatedStartDate, formatedEndDate, keySearch.value, keyValue).then((result) => {
            let sales = result.data.data;
            if (sales.length === 0) toast.info('No Records found', { autoClose: 1500 });
            setCurrentData(sales);
            let groupedStatus = [{ key: '-1', value: { name: 'Clear All' } }, ...groupByStatus(sales)];
            setSalesStatus(groupedStatus);
            setItems(sales);
         });
      } else {
         getSalesByDatesCriteria(formatedStartDate, formatedEndDate, '', '').then((result) => {
            let sales = result.data.data;
            if (sales.length === 0) toast.info('No Records found', { autoClose: 1500 });
            setCurrentData(sales);
            let groupedStatus = [{ key: '-1', value: { name: 'Clear All' } }, ...groupByStatus(sales)];
            setSalesStatus(groupedStatus);
            setItems(sales);
         });
      }
   };

   useEffect(fetchSales, []);

   return (
      <>
         <div className='container-fluid'>
            <div className='row'>
               <div className='col-md-2'>
                  <FilterBox
                     items={salesStatus}
                     selectedItem={(item) => item}
                     textProperty={(item) => item.value.name}
                     valueProperty={(item) => item.key}
                     onItemSelect={onSelectStatus}
                  />
               </div>
               <div className='col-md-10'>
                  <div className='row'>
                     <div className='col-md-6'>
                        <form className='form' onSubmit={handleSubmit}>
                           <div className='form-row align-items-center'>
                              <div className='form-group custom-form-group col-md-3'>
                                 <label htmlFor='startDate'>StartDate</label>
                                 <Input
                                    type='date'
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    dateFormat='dd/MM/yyyy'
                                    id='startDate'
                                    className='form-control form-control-sm custom-input'
                                 />
                              </div>
                              <div className='form-group custom-form-group col-md-3'>
                                 <label htmlFor='endDate'>End Date</label>
                                 <Input
                                    type='date'
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    dateFormat='dd/MM/yyyy'
                                    id='endDate'
                                    className='form-control form-control-sm custom-input'
                                 />
                              </div>
                           </div>
                           <div className='form-row'>
                              <div className='form-group col-md-3'>
                                 <SelectBox
                                    label='Search By'
                                    getOptionLabel={({ label }) => label}
                                    getOptionValue={({ value }) => value}
                                    value={keySearch}
                                    options={options}
                                    onChange={(selected) => setKeySearch(selected)}
                                    placeholder={'Search By ...'}
                                 />
                              </div>
                              <div className='form-group col-md-6'>
                                 <input
                                    type='text'
                                    className='form-control form-control-sm custom-input'
                                    placeholder='Search Value'
                                    id='phoneNumber'
                                    value={keyValue}
                                    onChange={(e) => setKeyValue(e.target.value)}
                                 />
                              </div>
                           </div>
                           <Button type='submit' className='btn btn-sm btn-custom text-white'>
                              <FaSearch /> Search
                           </Button>
                        </form>
                     </div>
                  </div>
                  <div className='row mt-2'>
                     <div className='col-md-12'>
                        <div className='form'>
                           <form className='form-inline justify-content-between'>
                              <div className='input-group input-group-sm mb-2 mr-sm-2'>
                                 <div className='input-group-prepend'>
                                    <div className='input-group-text'>
                                       <IoMdList />
                                    </div>
                                 </div>
                                 <Input
                                    name='searchBox'
                                    type='text'
                                    className='form-control custom-input'
                                    id='searchBox'
                                    value={filterValue}
                                    placeholder=''
                                    onChange={onSearch}
                                 />
                              </div>
                              <div>
                                 {!isAdmin ? (
                                    ''
                                 ) : (
                                    <CSVLink
                                       data={items}
                                       headers={exportHeaders}
                                       filename={'sales.csv'}
                                       target='_blank'
                                       className='btn-link-custom font-italic font-weight-normal'
                                    >
                                       Export CSV
                                    </CSVLink>
                                 )}
                              </div>
                           </form>
                           <div className='table-responsive'>
                              <DataTable items={items} pageSize={pageSize} rowKey={'transactionId'} columns={columns}></DataTable>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default SalesHistory;
